<template>
  <form id="gestorForm" @submit.prevent="submit()" class="ajax_off">
    <div class="form-group">
      <label>Selecione o gestor</label>
      <e-select v-model="gestor" route="colaboradores" />
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      gestor: Number(this.cartao.executor.devolver_user_id),
    };
  },
  props: {
    cartao: Object,
  }, 
  methods: {
    async submit() {
      await this.$api.put("tarefa/gestor", {
        id: this.cartao.executor.id,  
        user_id: this.gestor,
      });
      this.$emit("updateCartao");
      this.$bvModal.hide("gestor");
    },
  },
};
</script>